export default class Ergo {
    switch1=false
    switch2=false
    switch3=false
    switch4=false
    switch5=false
    switch6=false
    switch7=false
    switch8=false
    switch9=false
    switch10=false
    switch11=false
    switch12=false
    switch13=false
    switch14=false
    switch15=false
    switch16=false
    switch17=false
    switch18=false
    switch19=false
    switch20=false
    switch21=false
    switch22=false
    switch23=false
    switch24=false
    switch25=false
    switch26=false
    switch27=false
    switch28=false
    switch29=false
    switch30=false
    switch31=false
    switch32=false
    switch33=false
    switch34=false
    switch35=false
    switch36=false
    switch37=false
    switch38=false
    switch39=false
    switch40=false
    switch41=false
    switch42=false
    switch43=false
    switch44=false
    switch45=false
    switch46=false
    switch47=false
    switch48=false
    switch49=false
    switch50=false  
    informacionLaboral=[
        {valor:"", descripcion:"", tipo:20 ,label:"a. Datos de filiación:", bold:false},
        {valor:"", descripcion:"", tipo:21 ,label:"      C.I.: 1721930442", bold:false},
        {valor:"", descripcion:"", tipo:22 ,label:"      Edad: 32", bold:false},
        {valor:"", descripcion:"", tipo:23 ,label:"      Apellidos y nombres: LOPEZ CRISTIAN", bold:false},
        {valor:"", descripcion:"", tipo:24 ,label:"      Empresa: PRIVADOS", bold:false},
        {valor:"", descripcion:"", tipo:25 ,label:"      Puesto de trabajo: PRIVADO", bold:false},
        ]    
}


// WEBPACK FOOTER //
// ./src/model/Ergo.js